import { Navigate, Outlet } from "react-router-dom";

export default function ProtectedRoute() {
  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";

  // If logged in, render the nested routes (via Outlet)
  return isLoggedIn ? <Outlet /> : <Navigate to="/login" />;
}
